import type { OutboxItem } from './types';

/**
 * Where outbox items live: IndexedDB on the web, SQLite on native (F5). Every implementation passes `storeContract`.
 * - `put` inserts or replaces, and resolves only once the write is committed (a crash right after loses nothing).
 * - Reads hand out copies, so a caller changing an item never changes the store behind the engine's back.
 * - `list` is in `createdAt` order, ties by id: the engine's FIFO order.
 */
export interface OutboxStore {
  put(item: OutboxItem): Promise<void>;
  get(id: string): Promise<OutboxItem | undefined>;
  list(filter?: { userId?: number }): Promise<OutboxItem[]>;
  remove(id: string): Promise<void>;
  /** The id of every row, any user's, readable or not: what the orphan file sweep keeps. */
  ids(): Promise<string[]>;
}

export function byCreatedAt(a: OutboxItem, b: OutboxItem): number {
  if (a.createdAt !== b.createdAt) return a.createdAt < b.createdAt ? -1 : 1;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
